import React from "react";
import Bar from '../JSX/Bar';
import Footer from '../JSX/Footer';

const Models = () => {
  return (
        <div>
        <Bar/>
  {/* ======= Portfolio Section ======= */}
  <section id="portfomnd" className="portfolio" data-aos="fade-up">
    <div className="container">
      <div className="section-header">
        <h2>Models</h2>
        <p>
        The site provides some models for investors who have capital and want to enter the field of business, and there are a number of models that the investor can choose from, and the models have been divided into categories of capital. The investment models were filtered in the form of price categories to facilitate the selection of the appropriate project based on the price.
        </p>
      </div>
    </div>
    <div className="container-fluid" data-aos="fade-up" data-aos-delay={200}>
      <div
        className="portfolio-isotope"
        data-portfolio-filter="*"
        data-portfolio-layout="masonry"
        data-portfolio-sort="original-order"
      >
        <ul className="portfolio-flters">
          <li data-filter="*" className="filter-active">All</li>
          <li data-filter=".filter-100K">(100K - 1M)</li>
          <li data-filter=".filter-1M">(1M - 10M)</li>
          <li data-filter=".filter-10M">(10M - 100M)</li>
          <li data-filter=".filter-100M">(100M - 1B)</li>
        </ul>
        {/* End Portfolio Filters */}
        <div className="row g-0 portfolio-container">
          <div className="col-xl-3 col-lg-4 col-md-6 portfolio-item filter-1M">
            <img
              src='https://alsaa.net/webp/pic_157884_800.webp'
              className="img-fluid"
              href="/"
              alt="/"
            />
            <div className="portfolio-info">
              <h4>Playstation Cafe - 8M</h4>
              <a
                href="https://alsaa.net/webp/pic_157884_800.webp"
                title="متطلبات العمل: ثلاث اجهزة بلايستيشن، ثلاث شاشات مسطحة، أربعة اجهزة حاسوب، اشتراك شهري بالأنترنت "
                data-gallery="portfolio-gallery"
                className="glightbox preview-link"
              >
                <i className="bi bi-zoom-in" />
              </a>
              <a
                href="/Details"
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </a>
            </div>
          </div>
          {/* End Portfolio Item */}
          <div className="col-xl-3 col-lg-4 col-md-6 portfolio-item filter-1M">
            <img
              src="https://i.pinimg.com/564x/85/70/71/857071af543e255e23ed18fd363785b5.jpg"
              className="img-fluid"
              alt=""
            />
            <div className="portfolio-info">
              <h4>Mini Market - 9M</h4>
              <a
                href="https://i.pinimg.com/564x/85/70/71/857071af543e255e23ed18fd363785b5.jpg"
                title="البضاعة (مواد غذائية)، براد للمشروبات، الموقع طابق ارضي (لا يتطلب مساحة كبيرة)"
                data-gallery="portfolio-gallery"
                className="glightbox preview-link"
              >
                <i className="bi bi-zoom-in" />
              </a>
              <a
                href="portfolio-details.html"
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </a>
            </div>
          </div>
          {/* End Portfolio Item */}
          <div className="col-xl-3 col-lg-4 col-md-6 portfolio-item filter-10M">
            <img
              src="https://media.istockphoto.com/photos/all-your-necessities-stored-in-one-place-picture-id1157106624?s=612x612"
              className="img-fluid"
              alt=""
            />
            <div className="portfolio-info">
              <h4>Super Market - 24M</h4>
              <a
                href="https://media.istockphoto.com/photos/all-your-necessities-stored-in-one-place-picture-id1157106624?s=612x612"
                title="راس مال للبضاعة (مواد غذائية، مستلزمات، أدوات كافة...)، براد للمشروبات عدد 2 ,براد للمواد الغذائية، براد للمثلجات
                الموقع طابق ارضي (يتطلب مساحة كبيرة)"
                data-gallery="portfolio-gallery"
                className="glightbox preview-link"
              >
                <i className="bi bi-zoom-in" />
              </a>
              <a
                href="portfolio-details.html"
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </a>
            </div>
          </div>
          {/* End Portfolio Item */}
          <div className="col-xl-3 col-lg-4 col-md-6 portfolio-item filter-10M">
            <img
              src="https://www.superudisplay.com/wp-content/uploads/2020/09/ghana-shoes-bags-store-interior-design-2.jpg"
              className="img-fluid"
              alt=""
            />
            <div className="portfolio-info">
              <h4>Shoes Store - 10M</h4>
              <a
                href="https://www.superudisplay.com/wp-content/uploads/2020/09/ghana-shoes-bags-store-interior-design-2.jpg"
                title="Branding 1"
                data-gallery="portfolio-gallery"
                className="glightbox preview-link"
              >
                <i className="bi bi-zoom-in" />
              </a>
              <a
                href="portfolio-details.html"
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </a>
            </div>
          </div>
          {/* End Portfolio Item */}
          <div className="col-xl-3 col-lg-4 col-md-6 portfolio-item filter-100K">
            <img
              src="https://scx1.b-cdn.net/csz/news/800a/2020/workerscutan.jpg"
              className="img-fluid"
              alt=""
            />
            <div className="portfolio-info">
              <h4>PlexiGlass - 900K</h4>
              <a
                href="https://scx1.b-cdn.net/csz/news/800a/2020/workerscutan.jpg"
                title="App 2"
                data-gallery="portfolio-gallery"
                className="glightbox preview-link"
              >
                <i className="bi bi-zoom-in" />
              </a>
              <a
                href="portfolio-details.html"
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </a>
            </div>
          </div>
          {/* End Portfolio Item */}
          <div className="col-xl-3 col-lg-4 col-md-6 portfolio-item filter-10M">
            <img
              src="https://images.pexels.com/photos/3768005/pexels-photo-3768005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              className="img-fluid"
              alt=""
            />
            <div className="portfolio-info">
              <h4>Clothes Store - 10M</h4>
              <a
                href="https://images.pexels.com/photos/3768005/pexels-photo-3768005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                title="Product 2"
                data-gallery="portfolio-gallery"
                className="glightbox preview-link"
              >
                <i className="bi bi-zoom-in" />
              </a>
              <a
                href="portfolio-details.html"
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </a>
            </div>
          </div>
          {/* End Portfolio Item */}
          <div className="col-xl-3 col-lg-4 col-md-6 portfolio-item filter-100M">
            <img
              src="https://www.skistar.com/globalassets/bilder-nya-skistar.com/experium/gym.jpg?maxwidth=1400&quality=80"
              className="img-fluid"
              alt=""
            />
            <div className="portfolio-info">
              <h4>GYM - 250M</h4>
              <a
                href="https://www.skistar.com/globalassets/bilder-nya-skistar.com/experium/gym.jpg?maxwidth=1400&quality=80"
                title="Branding 2"
                data-gallery="portfolio-gallery"
                className="glightbox preview-link"
              >
                <i className="bi bi-zoom-in" />
              </a>
              <a
                href="portfolio-details.html"
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </a>
            </div>
          </div>
          {/* End Portfolio Item */}
          <div className="col-xl-3 col-lg-4 col-md-6 portfolio-item filter-10M">
            <img
              src="https://b2bcompliance.org.uk/wp-content/uploads/2019/11/electrical-store-1200x700.jpg"
              className="img-fluid"
              alt=""
            />
            <div className="portfolio-info">
              <h4>Electrical Store - 9M</h4>
              <a
                href="https://b2bcompliance.org.uk/wp-content/uploads/2019/11/electrical-store-1200x700.jpg"
                title="Branding 2"
                data-gallery="portfolio-gallery"
                className="glightbox preview-link"
              >
                <i className="bi bi-zoom-in" />
              </a>
              <a
                href="portfolio-details.html"
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </a>
            </div>
          </div>
          {/* End Portfolio Item */}
          <div className="col-xl-3 col-lg-4 col-md-6 portfolio-item filter-100M">
            <img
              src="https://scontent-mrs2-2.xx.fbcdn.net/v/t39.30808-6/272276273_3138419793076092_4827998186404170649_n.jpg?stp=dst-jpg_s960x960&_nc_cat=101&ccb=1-7&_nc_sid=e3f864&_nc_ohc=sxlTTpZZSakAX82Kx4V&_nc_ht=scontent-mrs2-2.xx&oh=00_AT-tJ1qgazGcu8m2yTPZlIkOalpO79wIEzv6pvuVMBy1Jw&oe=62CF42D9"
              className="img-fluid"
              alt=""
            />
            <div className="portfolio-info">
              <h4>Omaya Class - 500M</h4>
              <a
                href="https://scontent-mrs2-2.xx.fbcdn.net/v/t39.30808-6/272276273_3138419793076092_4827998186404170649_n.jpg?stp=dst-jpg_s960x960&_nc_cat=101&ccb=1-7&_nc_sid=e3f864&_nc_ohc=sxlTTpZZSakAX82Kx4V&_nc_ht=scontent-mrs2-2.xx&oh=00_AT-tJ1qgazGcu8m2yTPZlIkOalpO79wIEzv6pvuVMBy1Jw&oe=62CF42D9"
                title="App 3"
                data-gallery="portfolio-gallery"
                className="glightbox preview-link"
              >
                <i className="bi bi-zoom-in" />
              </a>
              <a
                href="portfolio-details.html"
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </a>
            </div>
          </div>
          {/* End Portfolio Item */}
        </div>
        {/* End Portfolio Container */}
      </div>
    </div>
  </section>
  {/* End Portfolio Section */}
        <Footer/>
        </div>
  );
};

export default Models;